import React, {Component} from 'react';
import './App.css';

import PropTypes, {bool} from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";

import axios from "axios";
import ReactGA from "react-ga";
import {connect} from 'react-redux';
import _ from 'lodash';
import {withSnackbar} from 'notistack';
import {urlConfig} from './config'
import {Card} from "@material-ui/core";
import {CardContent} from "@material-ui/core";
import qs from "qs";
import ReactTable from "react-table";
import PlayIcon from "@material-ui/icons/PlayCircleOutline"
import Container from "@material-ui/core/Container";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import Fab from "@material-ui/core/Fab";
import PlayArrow from "@material-ui/core/SvgIcon/SvgIcon";
import CircularProgress from "@material-ui/core/CircularProgress";
import DRMPlayer from "./DRMPlayer";

const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class DRMPlayerContainer extends Component {

    constructor(props) {
        super(props);
        let parsed = qs.parse(this.props.location.search);

        let cid = "";
        let url = "";
        let token = "";

        if (parsed["cid"] && parsed["cid"].length > 0) {
            cid = parsed["cid"];
        }

        if (parsed["?url"] && parsed["?url"].length > 0) {
            url = parsed["?url"];
        }

        if (parsed["token"] && parsed["token"].length > 0) {
            url = parsed["token"];
        }

        this.state = {
            cid: cid, url: url, drmToken: token
        };
    }

    componentDidMount() {

        console.log("in comp mount");


    }

    componentWillUnmount() {

    }

    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };


    playVideo(event) {
        event.preventDefault();
        let self = this;
        axios.get(`${urlConfig.bffUrl}/video/getDRMToken?drmType=Widevine&userId=udayshankar123&cid=${this.state.cid}`)
            .then((response) => {
                if (response && response.data && response.data.token) {
                    self.setState({drmToken: response.data.token})
                }
            });
    }


    render() {


        const {classes, theme} = this.props;

        return <React.Fragment>
            <Paper>
                <React.Fragment>
                    <Grid spacing={0}
                          container
                          direction="row"
                          justify="flex-start"
                          alignItems="center">
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            <form onSubmit={this.playVideo.bind(this)}>
                                <FormGroup row>
                                    <Grid spacing={2}
                                          container
                                          direction="row"
                                          justify="flex-start"
                                          alignItems="center">
                                        <Grid item xs={8}>
                                            <TextField
                                                id="outlined-url"
                                                label="URL"
                                                onChange={this.handleChange('url')}
                                                margin="normal"
                                                fullWidth
                                                multiline={true}
                                                rows={3}
                                                value={this.state.url}
                                                variant="outlined"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField
                                                id="outlined-cid"
                                                label="CID"
                                                onChange={this.handleChange('cid')}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                value={this.state.cid}
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button variant="contained" color="primary" type="submit"
                                                    size={"large"} className={classes.button}>
                                                Play
                                                <PlayIcon className={classes.rightIcon}/>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                            </form>
                            {this.state.url && (this.state.url != "") && (this.state.drmToken != "") &&
                            <DRMPlayer url={this.state.url} cid={this.state.cid} drmToken={this.state.drmToken}
                                       startTime={this.state.startTime}/>
                            }
                            <br/>
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>
                </React.Fragment>
            </Paper>

        </React.Fragment>
    }
}


DRMPlayerContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar((withStyles(styles, {withTheme: true})(DRMPlayerContainer)));
